import { EventTypeEnum, PositionDiscardReason } from '@quadminds/shared/tracking-system';
import { IAuditable } from './auditable-schema.interface';
import { IDeviceIdentificationSchema } from './device-identification-schema.interface';

export interface IEventSchema {
    id?: string;
    externalId: string;
    event: EventTypeEnum;
    latitude: string;
    longitude: string;
    timestamp: string;
    value?: string;
    createdAt?: string;
    updatedAt?: string;
    auditable: IAuditable;
    metadata?: IEventMetadata;
    origin?: string;
    trip?: IEventTrip;
    identification?: IDeviceIdentificationSchema;
    vehicleLicensePlate?: string;
    vehicleName?: string;
    carrier?: IEventCarrierSchema;
    /** False when the event belongs to another organization that shares the resource: read-only for this one. */
    isOwn?: boolean;
}

export interface IEventTrip {
    id: string;
    code: string;
}

export interface IEventsInfo {
    total?: number;
    totalResolved?: number;
    totalPending?: number;
}

export interface IEventZone {
    id?: string;
    name?: string;
    code?: string;
}

export interface IEventMetadata {
    duration?: number;
    info?: string;
    minSpeed?: number;
    maxSpeed?: number;
    discardCount?: number; // CORRUPT_FRAME: discarded positions in the episode
    reasons?: Partial<Record<PositionDiscardReason, number>>; // CORRUPT_FRAME: discarded positions per reason
}

export interface IEventCarrierSchema {
    id?: string;
    name?: string;
}
